import { dateTimeAsFileName } from 'src/shared/utils';

// reports/raport-30_07_2022_09_16.pdf
export const getExcelReportFileName = () => `raport-${dateTimeAsFileName()}.xlsx`;
